<template>
  <div class="project-member">
    <header class="topic-title">项目成员</header>
    <main v-loading="loading">
      <info-row v-for="(member, index) in members" :key="index" label-width="90">
        <template v-slot:label>
          <staff-popover :staffId="member.user.id">
            <template v-slot:reference>
              <el-tooltip
                :content="member.user.name || '无'"
                placement="top"
                :disabled="!member.user.id || member.user.id.length > 3"
              >
                <staff-avatar class="avatar" :size="30" :user="member.user"></staff-avatar>
              </el-tooltip>
            </template>
          </staff-popover>
          {{ member.user.name }}
        </template>
        <div class="position-wrap">
          <el-tooltip
            v-for="(role, index) in member.projectRoles"
            :key="index"
            :content="role.description"
            :disabled="!role.description"
          >
            <div class="position-item">{{ role.name }}</div>
          </el-tooltip>
        </div>
      </info-row>
    </main>
  </div>
</template>

<script>
import InfoRow from "./components/InfoRow"
import { getProjectMembers } from "@/api/project/project"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "project-member",
  components: { StaffAvatar, InfoRow, StaffPopover },
  props: {
    projectId: String
  },
  data() {
    return {
      loading: false,
      members: []
    }
  },
  created() {
    this.getMembers()
  },
  methods: {
    getMembers() {
      this.loading = true
      getProjectMembers(this.projectId).then(res => {
        this.members = res
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.project-member {
  ::v-deep .info-row {
    display: flex;
    margin-bottom: 18px;
    .label {
      display: flex;
      align-items: center;
      min-height: 30px;
      .avatar {
        flex-shrink: 0;
        margin-right: 10px;
        background-color: $color-auxiliary;
      }
    }
    .content {
      min-height: 30px;
      display: flex;
      align-items: center;
    }
  }
  .position-wrap {
    display: flex;
    flex-wrap: wrap;
    .position-item {
      padding: 0 7px;
      margin-right: 4px;
      margin-bottom: 4px;
      height: 22px;
      color: #3396fa;
      border-radius: 4px;
      border: 1px solid #a3d0fd;
      box-sizing: border-box;
    }
  }
}
</style>
